export const LIST_EMAILS = 'LIST_EMAILS';
export const UPDATE_EMAILS = 'UPDATE_EMAILS';
